"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsLocation = void 0;
var AnalyticsLocation;
(function (AnalyticsLocation) {
    AnalyticsLocation["FEED"] = "feed";
    AnalyticsLocation["BASE"] = "base";
    AnalyticsLocation["TIMELINE"] = "timeline";
    AnalyticsLocation["TASKS"] = "tasks";
    AnalyticsLocation["ANALYTICS"] = "analytics";
    AnalyticsLocation["NOTIFICATIONS"] = "notifications";
    AnalyticsLocation["SEARCH"] = "search";
})(AnalyticsLocation = exports.AnalyticsLocation || (exports.AnalyticsLocation = {}));
//# sourceMappingURL=index.js.map